import React from 'react';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { Box } from '@material-ui/core';


import 'primeflex/primeflex.css';
import '../../css/InitialData.css';


const InitialData = ({ setForm, formData }) => {

    const onInputChange = (e, name) => {
        const val = e.target.value;
        let _localForm = { ...formData };
        _localForm[`${name}`] = val;

        setForm(_localForm);
    }


    return (
        <div className="initialdata">
            <div className="p-field p-col-12 p-md-6">
                <h5 style={{ margin: '1px' }}>Ativado/Desativado</h5>
                <InputSwitch id="enabled" checked={formData.enableInitialData} onChange={(e) => onInputChange(e, 'enableInitialData')} />
            </div>

            {formData.enableInitialData ?
                <Box>
                    <div className="p-fluid p-grid">
                        <div className="p-field p-col-12 p-md-12"><h2>Informe os caminhos de cada planilha</h2></div>
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="employees">Planilha Funcionário</label>
                            <InputText id="funcionario" value={formData.employeesFilePath} onChange={(e) => onInputChange(e, 'employeesFilePath')} required autoFocus />
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="servicos">Planilha Serviços</label>
                            <InputText id="servicos" value={formData.servicesFilePath} onChange={(e) => onInputChange(e, 'servicesFilePath')} required />
                        </div>
                        <div className="p-field p-col-12 p-md-12">
                            <label htmlFor="modelos">Planilha Modelos</label>
                            <InputText id="modelos" value={formData.modelsFilePath} onChange={(e) => onInputChange(e, 'modelsFilePath')} required />
                        </div>

                    </div>
                </Box>
                : null
            }
        </div>
    );
}
export default InitialData;